import React from 'react';

const Header = () => (
    <div className="header bg-gradient-danger py-6">
        <div className="container-fluid">
            <div className="header-body">
                <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                        <h6 className="h2 text-white d-inline-block mb-0">Transferências Zwallet</h6>
                    </div>
                </div> 
            </div>
        </div>
    </div>
)

export default Header;


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/components/Header.js